const STORAGE_KEY = 'rsworks.remembered_access_guid.v1';

export function getRememberedAccessGuid() {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    return typeof v === 'string' && v.trim() ? v.trim() : '';
  } catch {
    return '';
  }
}

export function setRememberedAccessGuid(guid) {
  try {
    if (guid && typeof guid === 'string' && guid.trim()) {
      localStorage.setItem(STORAGE_KEY, guid.trim());
    }
  } catch {
    /* ignore quota / private mode */
  }
}

export function clearRememberedAccessGuid() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
